import axios from 'axios'
import APIConfig from '@/assets/js/data/remote/APIConfig.js'
import config from '@/assets/js/config.js'

export default class TeamBuyingService {
  constructor () {
    this.apis = {
      get: (id) => axios.get(APIConfig.BPIURL + `/teamBuying/${id}`),
      getAll: () => axios.get(APIConfig.BPIURL + '/teamBuying'),
      add: (payload) => axios.post(APIConfig.BPIURL + '/teamBuying', payload),
      edit: (id, payload) => axios.put(APIConfig.BPIURL + `/teamBuying/${id}`, payload),
      delete: (id) => axios.delete(APIConfig.BPIURL + `/teamBuying/${id}`),
      inActivate: (id) => axios.post(APIConfig.BPIURL + `/teamBuying/${id}/inactivate`)
    }

    // fake data
    if (config.useFakeData) {
      this.apis = {
        getAll: () => new Promise((resolve, reject) => {
          var res = {
            data: {
              status: 'ok',
              result: []
            }
          }
          resolve(res)
        })
      }
    }
  }

  fetchDatas (vm) {
    return this.getAll(vm).then(res => {
      vm.$store.state.teamBuying.list = res.data.result
    })
  }

  get (vm, id) {
    vm.isLoading = true
    return this.apis.get(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  getAll (vm) {
    vm.isLoading = true
    return this.apis.getAll()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  add (vm, payload) {
    vm.isLoading = true
    return this.apis.add(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  edit (vm, payload) {
    vm.isLoading = true
    return this.apis.edit(payload.ID, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  delete (vm, id) {
    vm.isLoading = true
    return this.apis.delete(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  inActivate (vm, id) {
    vm.isLoading = true
    return this.apis.inActivate(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}
